<script lang="ts">
  import SlipTable from './SlipTable.svelte';
  import { slipTypeChoice } from './config/store';
  import type { ChoiceDisplayMap } from 'scripts/utils/types';

  export let choiceDisplayMap: ChoiceDisplayMap = {};
  export let slipList = [];
  export let totalCount = 0;
  export let nextUrl: string | null = null;
  export let previousUrl: string | null = null;

  const tabs = Object.values($slipTypeChoice);
</script>

<SlipTable bind:slipList bind:choiceDisplayMap {totalCount} {nextUrl} {previousUrl} on:pageChange />
